<template>
  <div
    id="column-chart"
    ref="columnChart"
    style="width: 50%; height: 400px;"
  ></div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ColumnChart",
  props: {
    data: {
      type: Object,
      required: true
    },
    darkmode: String
  },
  mounted() {
    this.initChart();
    this.$watch(
      "data",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
    this.$watch(
      "darkmode",
      () => {
        this.updateChart();
      },
      { deep: true }
    );
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.columnChart);
      this.chart.setOption(this.getChartOption());
    },
    updateChart() {
      this.chart.setOption(this.getChartOption());
    },
    formatCurrency(value) {
      return value.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    getChartOption() {
      return {
        title: {
          text: "Faturamento mensal",
          left: "center",
          textStyle: {
            color: this.darkmode ? "#FFFFFF" : "#000000",
            fontWeight: "bold"
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        legend: {
          data: this.data.series.map((s) => s.name),
          bottom: 0
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "10%",
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.data.labels,
          axisLabel: {
            color: this.$store.state.darkmode ? "#FFFFFF" : "#000000",
          }
        },
        yAxis: {
          type: "value",
          axisLabel: {
            color: this.$store.state.darkmode ? "#FFFFFF" : "#000000",
          }
        },
        series: this.data.series.map((s) => ({
          name: s.name,
          type: "bar",
          data: s.data,
          barWidth: "40%",
          itemStyle: {
            color: s.color || undefined
          }
        }))
      };
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scoped>
#column-chart {
  width: 100%;
  height: 100%;
}
</style>
